function reverseFilter() {
  return items => (items ? items.slice().reverse() : null);
}

export default function (ngModule) {
  ngModule.filter('reverse', reverseFilter);
}
